module.exports = __webpack_public_path__ + "static/woyw-5-303311677ab809ef35b00c1f2079610b.png";